module.exports = __webpack_public_path__ + "media/images/lp_seiho/sec01_bg_01-6ae892375eaba97d63139bb56e2405e3.png";